'use client';

import { useTranslations } from '@dealerportal/i18n/client';
import { Skeleton } from '@dealerportal/ui-components/skeletons/Skeleton';
import type { FC } from 'react';
import { ProductToolbar } from '../ProductToolbar/ProductToolbar';

interface Props {
  title: React.ReactNode;
  productCount?: number;
  colorCount?: number;
  isMobileDevice: boolean;
  loading?: boolean;
}

export const ProductResultsBanner: FC<Props> = ({
  title,
  productCount,
  colorCount,
  isMobileDevice,
  loading,
}: Props) => {
  const t = useTranslations('products');

  return (
    <div>
      <div className="ui-flex ui-flex-row ui-justify-between ui-items-center ui-mb-4 md:ui-mb-6">
        <div>
          <h1 id="headline" className="!ui-text-left !ui-text-2xl">
            {title}
          </h1>
          {loading ? (
            <Skeleton className="ui-w-72 ui-h-5" />
          ) : (
            <div id="sub-headline" className="ui-text-[16px]">
              {t('browseResults', { count: productCount ?? 0 })} ({colorCount}{' '}
              {t('colors')})
            </div>
          )}
        </div>

        {!isMobileDevice && (
          <div className="ui-items-center ui-gap-2">
            <ProductToolbar />
          </div>
        )}
      </div>

      {isMobileDevice && (
        <div className="ui-items-center !ui-w-full">
          <ProductToolbar />
        </div>
      )}
    </div>
  );
};
